import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from '@myvf/core';
import {AemAppConfigResolver, AemGuard, AemMessagesResolver, MaintenanceResolver} from '@myvf/aem';
import {environment} from '../environments/environment';
import {AwsAppConfigResolver, CheckMsisdnResolver, CurrentMsisdnResolver} from '@myvf/shared';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AemGuard],
    resolve: {
      currentMsisdn: CurrentMsisdnResolver,
      appConfig: AemAppConfigResolver,
      awsConfig: AwsAppConfigResolver
    },
    children: [
      /////////////
      // Catalog //
      /////////////
      {
        path: 'content/myvf-business/webviews/catalog',
        loadChildren: () => import('./catalog/catalog.module').then((m) => m.CatalogModule)
      },
      {
        path: 'content/myvf-business/webviews/catalog.html',
        loadChildren: () => import('./catalog/catalog.module').then((m) => m.CatalogModule)
      },
      /////////
      // Puk //
      /////////
      {
        path: 'content/myvf-business/webviews/puk',
        loadChildren: () => import('./puk/puk.module').then((m) => m.PukModule)
      },
      {
        path: 'content/myvf-business/webviews/puk.html',
        loadChildren: () => import('./puk/puk.module').then((m) => m.PukModule)
      },

      //////////////
      // My Products //
      //////////////
      {
        path:'content/myvf-business/webviews/my-products',
        loadChildren: () => import('./my-products/my-products.module').then((m) => m.MyProductsModule)
      },
      {
        path:'content/myvf-business/webviews/my-products.html',
        loadChildren: () => import('./my-products/my-products.module').then((m) => m.MyProductsModule)
      },
      //////////////
      // COUNTERS //
      //////////////
      {
        path: 'content/myvf-business/webviews/counters',
        loadChildren: () => import('./counters/counters.module').then((m) => m.CountersModule)
      },
      {
        path: 'content/myvf-business/webviews/counters.html',
        loadChildren: () => import('./counters/counters.module').then((m) => m.CountersModule)
      },
      /////////////
      // Digital Solutions //
      /////////////
      {
        path: 'content/myvf-business/webviews/digital-solutions',
        loadChildren: () =>
          import('./digital-solutions/digital-solutions.module').then((m) => m.DigitalSolutionsModule)
      },
      {
        path: 'content/myvf-business/webviews/digital-solutions.html',
        loadChildren: () =>
          import('./digital-solutions/digital-solutions.module').then((m) => m.DigitalSolutionsModule)
      },
      //////////////
      // CONSENTS //
      //////////////
      {
        path: 'content/myvf-business/webviews/agreements',
        loadChildren: () => import('./agreements/agreements.module').then(m => m.AgreementsModule)
      },
      /////////////////////
      // NETWORK-GUARANT //
      ////////////////////
      {
        path: 'content/myvf-business/webviews/network-guarantee',
        loadChildren: () => import('./network-guarantee/network-guarantee.module').then(m => m.NetworkGuaranteeModule)
      },
      //////////////
      // OTP-SNOW //
      //////////////
      {
        path: 'content/myvf-business/webviews/otp-snow',
        loadChildren: () => import('./otp-snow/otp-snow.module').then((m) => m.OtpSnowModule)
      },
      {
        path: 'content/myvf-business/webviews/otp-snow.html',
        loadChildren: () => import('./otp-snow/otp-snow.module').then((m) => m.OtpSnowModule)
      },
      //////////////
      // ACTIVATION-WORKFLOW //
      //////////////
      {
        path: 'content/myvf-business/webviews/activation-workflow',
        loadChildren: () => import('./activation-workflow/activation-workflow.module').then((m) => m.ActivationWorkflowModule)
      },
      {
        path: 'content/myvf-business/webviews/activation-workflow.html',
        loadChildren: () => import('./activation-workflow/activation-workflow.module').then((m) => m.ActivationWorkflowModule)
      },
      //////////////
      //   NEWS   //
      //////////////
      {
        path: 'content/myvf-business/webviews/news',
        loadChildren: () => import('./news/news.module').then((m) => m.NewsModule)
      },
      {
        path: 'content/myvf-business/webviews/news.html',
        loadChildren: () => import('./news/news.module').then((m) => m.NewsModule)
      },
      /////////////////////
      //   CHANGE LINE   //
      /////////////////////
      {
        path: 'content/myvf-business/webviews/change',
        loadChildren: () => import('./change/change.module').then((m) => m.ChangeModule)
      },
      /////////////////////
      //   SURVEY        //
      /////////////////////
      {
        path: 'content/myvf-business/webviews/survey',
        loadChildren: () => import('./survey/survey.module').then((m) => m.SurveyModule)
      },
      {
        path: 'content/myvf-business/webviews/survey.html',
        loadChildren: () => import('./survey/survey.module').then((m) => m.SurveyModule)
      },
      /////////
      // Generic Error Page //
      /////////
      {
        path: 'content/myvf-business/webviews/generic-error-page',
        loadChildren: () =>
          import('./generic-error-page/generic-error-page.module').then((m) => m.GenericErrorPageModule)
      },
      {
        path: 'content/myvf-business/webviews/generic-error-page.html',
        loadChildren: () =>
          import('./generic-error-page/generic-error-page.module').then((m) => m.GenericErrorPageModule)
      },
    ]
  },
  //////////////////////
  // EXTERNAL ANCHORS //
  //////////////////////
  {
    path: '',
    canActivateChild: [AemGuard],
    children: [{
      path: 'content/myvf-business/webviews/external-anchors/anchor.html',
      loadChildren: () => import('./external-anchors/external-anchors.module').then(m => m.ExternalAnchorsModule)
    },
    /* -------------------------------------------------------------------------- */
    /*                            Roaming sponsor page                            */
    /* -------------------------------------------------------------------------- */
    {
      path: 'content/myvf-business/webviews/external-anchors/roaming.html',
      loadChildren : () => import('./roaming-sponsor-page/roaming-sponsor-page.module').then((m)=>m.RoamingSponsorPageModule)
    },

    /////////
    // Login Succesful //
    /////////
    {
      path: 'content/myvf-business/webviews/login-successful',
      loadChildren: () =>
        import('./login-successful/login-successful.module').then((m) => m.LoginSuccessfulModule)
    },
    {
      path: 'content/myvf-business/webviews/login-successful.html',
      loadChildren: () =>
        import('./login-successful/login-successful.module').then((m) => m.LoginSuccessfulModule)
    },]
  },
  //////////////////////
  // TEST PAGE //
  //////////////////////
  {
    path: '',
    children: [{
      path: 'content/myvf-business/webviews/test',
      loadChildren: () => import('./test/test.module').then(m => m.TestModule)
    }]
  },
  ///////////
  // Error //
  ///////////
  {
    path: '',
    canActivateChild: [AemGuard],
    children: [{
      path: 'content/myvf-business/webviews/error',
      loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
    }]
  },
  {
    path: 'content/myvf-business/webviews/error.html',
    canActivateChild: [AemGuard],
    children: [{
      path: 'content/myvf-business/webviews/error',
      loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
    }]
  },
  //////////////
  // Fallback //
  //////////////
  {
    path: '**',
    redirectTo: 'content/myvf-business/webviews/error/page-not-found.html',
    pathMatch: 'full'
  }
];

const devRoutes = [
  {
    path: 'login',
    resolve: {
      awsConfig: AwsAppConfigResolver
    },
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(environment.production ? routes : [...devRoutes, ...routes], {
      enableTracing: !environment.production,
      onSameUrlNavigation: 'reload'
    })
  ],
  providers: [CurrentMsisdnResolver, CheckMsisdnResolver, AemMessagesResolver, AemAppConfigResolver, MaintenanceResolver, AwsAppConfigResolver],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
